import React, { useEffect, useState } from 'react';

// Import the functions you need from the SDKs you need
import { initializeApp, FirebaseApp } from 'firebase/app';
import { getFirestore, Firestore } from 'firebase/firestore';
import { getAuth, Auth, onAuthStateChanged, User } from 'firebase/auth';
import { getAnalytics, Analytics } from 'firebase/analytics';

type FirebaseState = {
  app: FirebaseApp;
  auth: Auth;
  db: Firestore;
  analytics: Analytics;
  user: User | null;
};

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: 'AIzaSyB9QiDB15stjISnTkW5nai8h4D1lLCTtdk',
  authDomain: 'waitlist-f94c0.firebaseapp.com',
  projectId: 'waitlist-f94c0',
  storageBucket: 'waitlist-f94c0.appspot.com',
  messagingSenderId: '36884332576',
  appId: '1:36884332576:web:16c05af8cbc76a27dcfc45',
  measurementId: 'G-S9Q9W56Z5G',
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);
const analytics = getAnalytics(app);

const defaultValue = {
  app,
  auth,
  db,
  analytics,
  user: null,
};

export const FirebaseContext = React.createContext<FirebaseState>(defaultValue);

export const FirebaseContextProvider: React.FC<{
  children: React.ReactElement;
}> = ({ children }) => {
  const [user, setUser] = useState<User | null>(null);

  useEffect(
    () => onAuthStateChanged(auth, (currentUser) => setUser(currentUser)),
    [auth]
  );

  return (
    <FirebaseContext.Provider value={{ ...defaultValue, user }}>
      {children}
    </FirebaseContext.Provider>
  );
};
